/* eslint-env browser */
/*
 * Slideshow component for cycling through elements, like a carousel.
 *
 * https://getbootstrap.com/docs/3.4/javascript/#carousel
 */
require('../bootstrap/js/carousel');
